// @ts-nocheck
// ═══════════════════════════════════════════════════════════════════════════
//  /pay/{token} — ΔΗΜΟΣΙΑ ΣΕΛΙΔΑ ΠΛΗΡΩΜΗΣ
//  ---------------------------------------------------------------------------
//  Ίδιος PaymentAdapter, ίδιοι πίνακες, ίδιο ντύσιμο (tokens.css) με το βήμα
//  «Πληρωμές» του Agreement. Ο σύνδεσμος λήγει (προεπιλογή 7 ημέρες) και
//  «καίγεται» μόλις ξεκινήσει πληρωμή.
// ═══════════════════════════════════════════════════════════════════════════
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { cancelLinkAttempt, getLink, startLink, PayBlock } from './services/paymentsService';
import { formatMoneyEU } from './utils/format';
import { depositPhrase } from './utils/paySummary';
import { formatDateEU } from './utils/dateFormat';
import PriceBreakdownPopup from './components/PriceBreakdownPopup';

/* ═══ ΜΟΝΑΔΙΚΗ ΑΠΟΚΛΙΣΗ ΑΠΟ ΤΟ v2 — ΜΗΝ ΤΗ ΣΒΗΣΕΙΣ ΣΕ ΕΠΟΜΕΝΟ SYNC ══════════
   Στο v2 το tokens.css φορτώνεται ΚΑΘΟΛΙΚΑ από το src/index.tsx. Στο prod ΔΕΝ
   φορτώνεται από πουθενά αλλού — αυτή η γραμμή ήταν η μόνη του είσοδος. Όταν
   έφυγε (sync του PayPage από το v2), το CSS bundle έχασε ΟΛΕΣ τις .yms-*
   κλάσεις (4,95 kB → 1,31 kB) και η σελίδα πληρωμής έβγαινε άστυλη.
   Αν κάποτε το prod index.tsx φορτώσει το tokens.css, τότε φύγε από εδώ. */
import './styles/tokens.css';

const T: Record<string, any> = {
  el: { title:'Πληρωμή ναύλου', booking:'Ναύλος', vessel:'Σκάφος', dates:'Ημερομηνίες',
        amount:'Ποσό προς πληρωμή', pay:'Πληρωμή', expires:'Ο σύνδεσμος λήγει',
        expired:'Ο σύνδεσμος έχει λήξει.', used:'Ο σύνδεσμος έχει ήδη χρησιμοποιηθεί.',
        cancelled:'Ο σύνδεσμος ακυρώθηκε.', invalid:'Μη έγκυρος σύνδεσμος.',
        noProvider:'Δεν υπάρχει διαθέσιμος τρόπος πληρωμής αυτή τη στιγμή.',
        instructions:'Οδηγίες πληρωμής', openPos:'Άνοιγμα Virtual POS',
        email:'Email (προαιρετικό, για την απόδειξη)', working:'Παρακαλώ περιμένετε…',
        purpose_balance:'Υπόλοιπο ναύλου', purpose_deposit:'Εγγύηση',
        purpose_damage_waiver:'Damage waiver', purpose_extra:'Extras', purpose_charter_pack:'Charter pack', purpose_custom:'Πληρωμή', purpose_mixed:'Πληρωμή',
        includes:'Τι περιλαμβάνει', optional:'προαιρετικό — επιλέξτε', inCharter:'συμφωνημένο στον ναύλο', instalment:'Δόση ναύλου', ofCharter:'του ναύλου', extrasTitle:'Extras', extrasHint:'αφαιρέστε ό,τι δεν θέλετε · «στον ναύλο» = ήδη συμφωνημένο', pickInstalment:'Επιλέξτε δόση για να συνεχίσετε.', back:'← Πίσω στις επιλογές', cancelledRetry:'Η πληρωμή ακυρώθηκε — μπορείτε να προσπαθήσετε ξανά.', cannotCancel:'Η πληρωμή έχει ήδη ξεκινήσει και δεν ακυρώνεται από εδώ — επικοινωνήστε μαζί μας.', awaiting:'Αναμονή για επιβεβαίωση πληρωμής από την τράπεζα ({n} δευτ.)… Μην κλείσετε τη σελίδα.', total:'Σύνολο',
        thanks:'Ευχαριστούμε! Η πληρωμή καταχωρήθηκε.', receipt:'Λήψη απόδειξης (PDF)',
        charter:'Ναύλος', paidNote:'Θα λάβετε επιβεβαίωση με email.',
        how:'Τρόπος πληρωμής',
        u_day:'ημέρα', u_days:'ημέρες', u_week:'εβδομάδα', u_weeks:'εβδομάδες',
        u_person:'άτομο', u_persons:'άτομα',
        sandbox:'ΔΟΚΙΜΑΣΤΙΚΟ — Sandbox. Καμία πραγματική χρέωση.',
        due:'λήξη', overdue:'ληξιπρόθεσμη',
        planTitle:'Πρόγραμμα πληρωμών ναύλου',
        stPaid:'πληρωμένη', stNow:'πληρωτέα τώρα', stPending:'εκκρεμεί',
        terms:'Όροι πληρωμής & ακύρωσης', termsRead:'Διαβάστε τους όρους',
        termsAccept:'Έχω διαβάσει και αποδέχομαι τους όρους πληρωμής & ακύρωσης.',
        termsRequired:'Πρέπει να αποδεχθείτε τους όρους για να συνεχίσετε.',
        alreadyTitle:'Ήδη πληρωμένα', alreadyExtras:'Ήδη πληρωμένα extras',
        alreadyPack:'Charter pack', alreadyDep:'Εγγύηση', packYes:'πληρωμένο',
        depHeldTitle:'Η εγγύηση είναι ήδη δεσμευμένη',
        depHeldNote:'Το ποσό είναι δεσμευμένο στην κάρτα σας και θα αποδεσμευτεί μετά το check-out. Δεν χρειάζεται καμία ενέργεια.',
        depositNote:'Το ποσό δεσμεύεται ως εγγύηση και αποδεσμεύεται μετά το check-out.',
        payment:'Πληρωμή', payer:'Στοιχεία πελάτη',
        waiverNote:'Το damage waiver χρεώνεται εφάπαξ και αντικαθιστά τη δέσμευση εγγύησης.',
        close:'Κλείσιμο' },
  en: { title:'Charter payment', booking:'Booking', vessel:'Vessel', dates:'Dates',
        amount:'Amount to pay', pay:'Pay', expires:'Link expires',
        expired:'This link has expired.', used:'This link has already been used.',
        cancelled:'This link was cancelled.', invalid:'Invalid link.',
        noProvider:'No payment method is available right now.',
        instructions:'Payment instructions', openPos:'Open Virtual POS',
        email:'Email (optional, for the receipt)', working:'Please wait…',
        purpose_balance:'Charter balance', purpose_deposit:'Security deposit',
        purpose_damage_waiver:'Damage waiver', purpose_extra:'Extras', purpose_charter_pack:'Charter pack', purpose_custom:'Payment', purpose_mixed:'Payment',
        includes:'What this covers', optional:'optional — tick to add', inCharter:'agreed in your charter', instalment:'Charter instalment', ofCharter:'of the charter', extrasTitle:'Extras', extrasHint:'untick anything you don’t want · “in your charter” = already agreed', pickInstalment:'Please choose an instalment to continue.', back:'← Back to my choices', cancelledRetry:'The payment was cancelled — you can try again.', cannotCancel:'This payment has already started and cannot be cancelled here — please contact us.', awaiting:'Waiting for the bank to confirm your payment ({n}s)… Please do not close this page.', total:'Total',
        thanks:'Thank you! Your payment has been recorded.', receipt:'Download receipt (PDF)',
        charter:'Charter', paidNote:'You will receive a confirmation by email.',
        how:'Payment method',
        u_day:'day', u_days:'days', u_week:'week', u_weeks:'weeks',
        u_person:'person', u_persons:'people',
        sandbox:'TEST — Sandbox. No real charge.',
        due:'due', overdue:'overdue',
        planTitle:'Charter payment schedule',
        stPaid:'paid', stNow:'due now', stPending:'upcoming',
        terms:'Payment & cancellation terms', termsRead:'Read the terms',
        termsAccept:'I have read and accept the payment & cancellation terms.',
        termsRequired:'You must accept the terms to continue.',
        alreadyTitle:'Already paid', alreadyExtras:'Extras already paid',
        alreadyPack:'Charter pack', alreadyDep:'Security deposit', packYes:'paid',
        depHeldTitle:'The security deposit is already on hold',
        depHeldNote:'The amount is held on your card and will be released after check-out. Nothing further is needed.',
        depositNote:'The amount is held as a security deposit and released after check-out.',
        payment:'Payment', payer:'Customer',
        waiverNote:'The damage waiver is a one-off charge and replaces the security deposit hold.',
        close:'Close' },
};
['it','de','ru','fr','ro','pl','he','es'].forEach(l => { if (!T[l]) T[l] = T.en; });

export default function PayPage() {
  const { token } = useParams();
  const [link, setLink] = useState<any>(null);
  const [err, setErr] = useState('');
  /* Ενημέρωση, ΟΧΙ σφάλμα: «η πληρωμή ακυρώθηκε, δοκιμάστε ξανά» δεν πρέπει να
     βγαίνει κόκκινο σαν να χάλασε κάτι. */
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(false);
  const [email, setEmail] = useState('');
  const [handoff, setHandoff] = useState<any>(null);
  const [picked, setPicked] = useState<Record<string, boolean>>({});
  /* ΠΑΡΟΧΟΣ: όταν είναι ενεργοί περισσότεροι από ένας (π.χ. «κάρτα» και
     «τραπεζικό έμβασμα»), διαλέγει Ο ΠΕΛΑΤΗΣ. Με έναν, δεν ρωτάμε τίποτα. */
  const [prov, setProv] = useState('');
  /* ΔΟΣΗ ΝΑΥΛΟΥ: ο σύνδεσμος του Agreement ρωτά ΠΟΙΑ πληρώνει ο πελάτης. Καμία
     προεπιλογή — μια λάθος «προεπιλεγμένη» δόση σημαίνει λάθος ποσό. */
  const [inst, setInst] = useState('');
  /* ═══ ΟΙ ΟΡΟΙ ΕΙΝΑΙ ΠΡΟΫΠΟΘΕΣΗ, ΟΧΙ ΣΗΜΕΙΩΣΗ ═══════════════════════════════
     Χωρίς τικ, ΚΑΝΕΝΑ κουμπί πληρωμής δεν ενεργοποιείται. Ο σύνδεσμος του
     email δείχνει στο #terms, οπότε ο πελάτης που πάτησε «Όροι πληρωμής»
     βρίσκει το κείμενο ήδη ανοιχτό. */
  const [termsOk, setTermsOk] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [termsLang, setTermsLang] = useState<'en' | 'el'>('en');

  /* Τα ΗΔΗ ΣΥΜΦΩΝΗΜΕΝΑ extras έρχονται τικαρισμένα. Ο πελάτης δεν ξέρει ποια
     από τα 21 του καταλόγου είχε συμφωνήσει στον ναύλο — τα ξεχνούσε και
     πλήρωνε λιγότερα. Το `in_charter` το στέλνει ο server μέσα στο σκέλος.
     Τρέχει ΜΙΑ φορά (pickedInit): αν ο πελάτης ξετικάρει κάτι, δεν το
     ξαναβάζουμε στο επόμενο render. */
  const pickedInit = useRef(false);
  /* Η αυτόματη ακύρωση δοκιμάζεται ΜΙΑ φορά ανά φόρτωση — αλλιώς θα έμπαινε σε
     βρόχο με το re-render που η ίδια προκαλεί. */
  const autoCancelTried = useRef(false);

  /* ═══ ΠΑΡΑΘΥΡΟ ΧΑΡΙΤΟΣ ΤΟΥ SERVER ═════════════════════════════════════════
     Ο server αρνείται να ακυρώσει απόπειρα νεότερη από 2 λεπτά: η επιβεβαίωση
     της τράπεζας (webhook) φτάνει δευτερόλεπτα ΜΕΤΑ την επιστροφή του πελάτη,
     και μια βιαστική ακύρωση έσβηνε πληρωμή που είχε ήδη περάσει. Αντί για
     σφάλμα, απαντά wait_seconds — εδώ τα μετράμε αντίστροφα και ξαναρωτάμε. */
  const [waitLeft, setWaitLeft] = useState(0);
  const waitTick = useRef<any>(null);
  const aliveRef = useRef(true);
  useEffect(() => () => {
    aliveRef.current = false;
    if (waitTick.current) clearInterval(waitTick.current);
  }, []);

  const countdown = (secs: number) => new Promise<void>(resolve => {
    let left = Math.max(1, Math.min(180, Math.ceil(secs)));
    setWaitLeft(left);
    if (waitTick.current) clearInterval(waitTick.current);
    waitTick.current = setInterval(() => {
      if (!aliveRef.current) { clearInterval(waitTick.current); waitTick.current = null; return; }
      left -= 1;
      setWaitLeft(left > 0 ? left : 0);
      if (left <= 0) { clearInterval(waitTick.current); waitTick.current = null; resolve(); }
    }, 1000);
  });

  /* Μία ακύρωση, με όση αναμονή ζητήσει ο server.
       reopened → η απόπειρα ξετυλίχθηκε, ο σύνδεσμος ξανά ανοιχτός
       already  → κάτι εισπράχθηκε· ο σύνδεσμος ΜΕΝΕΙ used, όπως πρέπει
       open     → ήταν ήδη ανοιχτός, τίποτα να κάνουμε */
  const attemptCancel = async (): Promise<{ result: string; message?: string }> => {
    // Ο server δίνει ≤120 δευτ. και μετά απαντά οριστικά· τα 3 είναι δικλείδα
    // για οριακή διαφορά ρολογιού, ποτέ κανονική διαδρομή.
    for (let round = 0; round < 3; round++) {
      let c: any;
      try {
        c = await cancelLinkAttempt(token as string);
      } catch (e: any) {
        setWaitLeft(0);
        return { result: e?.message === 'payment_already_started' ? 'already' : 'error',
                 message: e?.message };
      }
      const w = Number(c?.wait_seconds) || 0;
      if (w > 0) { await countdown(w); if (!aliveRef.current) return { result: 'gone' }; continue; }
      setWaitLeft(0);
      return { result: c?.reopened ? 'reopened' : 'open' };
    }
    setWaitLeft(0);
    return { result: 'open' };
  };

  const applyLink = (d: any) => {
    setLink(d);
    /* ΠΡΟΕΠΙΛΕΓΜΕΝΟΣ ΠΑΡΟΧΟΣ, ΠΑΝΤΑ. Χωρίς αυτό, με δύο ενεργούς παρόχους τα
       κουμπιά «Πληρωμή» έμεναν disabled μέχρι να πατήσει ο πελάτης έναν — και
       δεν του έλεγε κανείς γιατί. */
    const av = (d?.providers || []).filter((p: any) => p.provider !== 'manual');
    if (av.length) setProv((cur: string) => cur || av[0].provider);
    if (!pickedInit.current) {
      pickedInit.current = true;
      const pre: Record<string, boolean> = {};
      /* ΤΙΚΑΡΙΣΜΕΝΑ ΟΣΑ ΕΣΤΕΙΛΕ Ο ΥΠΑΛΛΗΛΟΣ — ΟΧΙ ΟΙ ΠΡΟΤΑΣΕΙΣ.
         Το μπλοκ extras έχει δύο στρώσεις: επάνω ό,τι στάλθηκε επίτηδες (ο
         πελάτης ΑΦΑΙΡΕΙ), από κάτω ο υπόλοιπος τιμοκατάλογος με `offer: true`
         (ο πελάτης ΠΡΟΣΘΕΤΕΙ). Αν τικάρονταν και οι προτάσεις, ο πελάτης θα
         έβλεπε λογαριασμό για 21 extras ενώ συμφώνησε 7. */
      (d?.items || []).forEach((it: any) => {
        // Τα ήδη πληρωμένα ΠΟΤΕ προεπιλεγμένα — αλλιώς ο πελάτης ξαναπληρώνει χωρίς να το θέλει.
        if (it?.optional && !it?.offer && !it?.paid && it?.code) pre[it.code] = true;
      });
      if (Object.keys(pre).length) setPicked(pre);

      /* ΜΙΑ ΔΟΣΗ ΣΤΟΝ ΣΥΝΔΕΣΜΟ = ΑΥΤΗ ΖΗΤΗΘΗΚΕ — ΠΡΟΕΠΙΛΕΓΜΕΝΗ.
         Ο υπάλληλος έστειλε ρητά τη 2η δόση· δεν υπάρχει τίποτα να διαλέξει ο
         πελάτης, κι όμως η σελίδα άνοιγε με το radio κενό και σύνολο μόνο τα
         extras — σαν να μην είχε σταλεί δόση. Με περισσότερες από μία ΔΕΝ
         προεπιλέγουμε: εκεί η επιλογή είναι πραγματικά δική του. */
      const io_: any[] = d?.instalments || [];
      if (io_.length === 1) setInst(String(io_[0].key));
    }
  };

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        let d = await getLink(token as string);
        if (!alive) return;

        /* ═══ ΕΠΙΣΤΡΟΦΗ ΑΠΟ ΤΟΝ ΠΑΡΟΧΟ ΧΩΡΙΣ ΠΛΗΡΩΜΗ ═══════════════════════
           Ο πάροχος γυρίζει τον πελάτη στο ΙΔΙΟ /pay/{token} — δεν υπάρχει
           ξεχωριστός handler ούτε «success flag» στο URL. Και δεν θα
           στηριζόμασταν σε ένα: το URL το ελέγχει ο browser και μπορεί να
           χαθεί ή να πλαστογραφηθεί.

           Η ΑΛΗΘΕΙΑ ΕΙΝΑΙ ΣΤΟΝ SERVER: ο σύνδεσμος είναι `used` επειδή
           ξεκίνησε πληρωμή, αλλά αν ΚΑΜΙΑ γραμμή δεν προχώρησε (όλες pending)
           τότε ο πελάτης ακύρωσε ή απέτυχε. Το ίδιο action=cancel με το
           χειροκίνητο «Πίσω» — ο server αρνείται (409) αν κάτι εισπράχθηκε,
           οπότε μια επιτυχημένη πληρωμή δεν ξετυλίγεται ποτέ κατά λάθος. */
        if (d?.status === 'used' && !autoCancelTried.current) {
          autoCancelTried.current = true;
          /* Η σελίδα δείχνει ΗΔΗ τον σύνδεσμο όσο περιμένουμε — αλλιώς ο πελάτης
             κοιτούσε λευκή οθόνη για δύο λεπτά. */
          applyLink(d);
          const c = await attemptCancel();
          if (!alive) return;
          if (c.result === 'reopened' || c.result === 'already') {
            d = await getLink(token as string);
            if (!alive) return;
            if (c.result === 'reopened') {
              setNotice(T[d?.language || 'en']?.cancelledRetry || T.en.cancelledRetry);
            }
          }
          // 'already' = η πληρωμή πέρασε· ο σύνδεσμος μένει used, όπως πρέπει.
        }

        if (alive) applyLink(d);
      } catch (e: any) {
        if (alive) setErr(e?.message || 'invalid_token');
      }
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const t = T[link?.language || 'en'] || T.en;

  /* «100,00 € × 7 ημέρες» — ΓΙΑΤΙ βγαίνει αυτό το ποσό. Τα στοιχεία τα στέλνει
     ο server μέσα στο σκέλος (unit/qty/unit_price_cents): η σελίδα δεν
     υπολογίζει χρήματα, μόνο τα εξηγεί. */
  const unitNote = (it: any) => {
    const qty = Number(it?.qty) || 0;
    const each = Number(it?.unit_price_cents) || 0;
    if (!qty || qty <= 1 || !each || it?.unit === 'charter') return null;
    const w = t[`u_${it.unit}${qty === 1 ? '' : 's'}`] || '';
    return <>{formatMoneyEU(each / 100)} × {qty} {w}</>;
  };

  /* Η απόδειξη φορτώνεται ΔΥΝΑΜΙΚΑ: το ίδιο PayPage σερβίρεται και από το prod,
     όπου το pdfTemplateService δεν έχει (ακόμη) τη γεννήτρια αποδείξεων. Αν
     λείπει, το κουμπί το λέει αντί να σκάσει η σελίδα. */
  const downloadReceipt = async (r: any) => {
    try {
      const m: any = await import('./services/pdfTemplateService');
      if (typeof m.generatePaymentReceiptPDF === 'function') { await m.generatePaymentReceiptPDF(r); return; }
    } catch (e) { /* πέφτουμε στο μήνυμα από κάτω */ }
    setErr('Η απόδειξη θα σταλεί με email.');
  };

  /* ΜΙΑ ΠΛΗΡΩΜΗ ΑΝΑ ΜΠΛΟΚ. Το `block` λέει στον server ΤΙ ακριβώς πληρώνεται —
     χωρίς αυτό χρέωνε όλα τα υποχρεωτικά σκέλη μαζί (π.χ. και το charter pack
     όταν ο πελάτης πατούσε το κουμπί των extras). */
  const start = async (block: PayBlock) => {
    setBusy(true); setErr('');
    try {
      const r = await startLink(token as string, email,
        block === 'extra' ? Object.keys(picked).filter(k => picked[k]) : [],
        prov, block === 'instalment' ? inst : '', block);
      if (r.redirect_url) { window.location.href = r.redirect_url; return; }
      setHandoff(r);
    } catch (e: any) {
      setErr(e.message || 'error');
    } finally { setBusy(false); }
  };

  /* «ΠΙΣΩ» ΠΡΙΝ ΤΗΝ ΠΛΗΡΩΜΗ. Μόλις πατηθεί «Πληρωμή», ο σύνδεσμος καίγεται
     (status=used) ώστε να μην ξαναχρεώσει — οπότε ένα σκέτο «πίσω» θα άφηνε τον
     πελάτη σε νεκρό σύνδεσμο. Εδώ ζητάμε από τον server να ξετυλίξει την
     απόπειρα· αν κάτι έχει ήδη εισπραχθεί, αρνείται και το λέμε. Η επιλογή του
     πελάτη (picked / δόση / email) ΔΕΝ πειράζεται — μένει ως έχει. */
  /* Ο σύνδεσμος «Όροι πληρωμής» του email δείχνει στο #terms: μόλις φορτώσει η
     σελίδα, το modal ανοίγει μόνο του στη γλώσσα του συνδέσμου. */
  useEffect(() => {
    if (!link) return;
    setTermsLang(link.language === 'el' ? 'el' : 'en');
    if (typeof window !== 'undefined' && window.location.hash === '#terms') setTermsOpen(true);
  }, [link?.language]);

  const goBack = async () => {
    setBusy(true); setErr(''); setNotice('');
    try {
      const c = await attemptCancel();
      if (c.result === 'gone') return;
      if (c.result === 'error') { setErr(c.message || 'error'); return; }
      const fresh = await getLink(token as string);
      setLink(fresh);
      // Πληρώθηκε όσο περιμέναμε: το λέμε και ΔΕΝ γυρνάμε στις επιλογές.
      if (c.result === 'already') { setErr(t.cannotCancel); return; }
      setHandoff(null);
    } catch (e: any) {
      setErr(e?.message || 'error');
    } finally { setBusy(false); }
  };

  /* Το σύνολο ακολουθεί τις επιλογές του πελάτη — ο server το ξαναϋπολογίζει
     πριν χρεώσει, οπότε αυτό εδώ είναι ΜΟΝΟ εμφάνιση. */
  const instOptions: any[] = link?.instalments || [];
  const instChosen = instOptions.find((o: any) => o.key === inst) || null;
  const instCents = instChosen ? (instChosen.amount_cents || 0) : 0;

  /* ═══ ΟΙ ΟΡΟΙ ΤΗΣ ΒΑΣΗΣ ════════════════════════════════════════════════════
     Έρχονται και στις δύο γλώσσες. Δείχνουμε τη γλώσσα του συνδέσμου· αν η βάση
     δεν έχει γράψει το ελληνικό, πέφτουμε στο αγγλικό — κενό modal «Όροι
     πληρωμής» είναι χειρότερο από όρους σε άλλη γλώσσα. */
  /* ΟΛΟ το πρόγραμμα του ναύλου, με κατάσταση ανά γραμμή. Κενό όταν ο σύνδεσμος
     δεν αφορά τον ναύλο (μόνο extras / pack / εγγύηση) — ο server το κρίνει. */
  /* ═══ ΑΥΤΟΝΟΜΟΣ ΣΥΝΔΕΣΜΟΣ ═══════════════════════════════════════════════════
     Χωρίς ναύλο: ένα μπλοκ, ένα κουμπί. Καμία δόση, κανένα extra, κανένας όρος
     ναύλου — τα ρωτά ο πελάτης «τι σχέση έχουν με μένα;» και έχει δίκιο. */
  const isStandalone = !!link?.standalone;
  const standaloneItems: any[] = isStandalone ? (link?.items || []) : [];

  const planView: any[] = link?.instalment_plan || [];

  /* ═══ ΤΙ ΕΧΕΙ ΗΔΗ ΠΛΗΡΩΘΕΙ ΕΚΤΟΣ ΝΑΥΛΟΥ ══════════════════════════════════════
     Χωρίς αυτό, ο πελάτης που πλήρωσε extras την περασμένη βδομάδα βλέπει σκέτο
     ποσό ναύλου και ρωτά αν χάθηκαν τα λεφτά του. Τα νούμερα έρχονται από το
     yms_pay_summary μέσω του GET — η σελίδα δεν αθροίζει τίποτα. */
  const paidExtrasCents = (link as any)?.extras_paid_cents || 0;
  const paidExtrasN     = (link as any)?.extras_paid_n || 0;
  const paidPackCents   = (link as any)?.pack_paid_cents || 0;
  const depPhrase       = depositPhrase((link as any)?.deposit_row, (link?.language === 'el' ? 'el' : 'en'));
  const hasAlready      = paidExtrasCents > 0 || paidPackCents > 0 || !!depPhrase;

  const termsTexts = (link?.terms || { en: '', el: '' }) as { en: string; el: string };
  const hasTerms = !!(termsTexts.en || termsTexts.el);

  /* ═══ ΟΙ ΟΡΟΙ ΑΦΟΡΟΥΝ ΤΟΝ ΝΑΥΛΟ, ΟΧΙ ΤΗΝ ΕΓΓΥΗΣΗ ══════════════════════════
     Οι «Όροι πληρωμής & ακύρωσης» λένε πότε πληρώνεται ο ναύλος και τι γίνεται
     σε ακύρωση. Δεν έχουν καμία σχέση με μια δέσμευση εγγύησης, με ένα extra ή
     με το charter pack — και ένα υποχρεωτικό τικ εκεί απλώς εμπόδιζε τον
     πελάτη να κάνει κάτι άσχετο με αυτά που διάβαζε. */
  const CHARTER_BLOCKS = ['instalment', 'custom', 'balance'];
  const blockNeedsTerms = (b: string) => hasTerms && CHARTER_BLOCKS.indexOf(b) >= 0;
  const termsBody = (termsLang === 'el' ? termsTexts.el : termsTexts.en)
                 || termsTexts.en || termsTexts.el || '';

  /* Η ΔΟΣΗ ΕΙΝΑΙ Ο ΝΑΥΛΟΣ. Σύνδεσμος με δόσεις ΚΑΙ σκέλος «Charter balance»
     έδειχνε ναύλο 3.000 € + δόση 900 € = 3.900 €. Η σελίδα κρύβει το σκέλος
     του ναύλου όταν υπάρχουν δόσεις — ίδιος κανόνας με τον server, ώστε το
     σύνολο που βλέπει ο πελάτης να είναι ΑΥΤΟ που θα χρεωθεί. */
  const shownItems: any[] = !link ? []
    : (link.items || []).filter((it: any) => !(instOptions.length && it.purpose === 'balance'));

  /* ΙΔΙΑ ΔΟΜΗ ΜΕ ΤΟ ΠΑΡΑΘΥΡΟ ΤΟΥ ΥΠΑΛΛΗΛΟΥ (PaymentLinkDialog): τα υποχρεωτικά
     σκέλη σαν σειρές, τα extras σε ΠΛΕΓΜΑ με τα «στον ναύλο» ΠΡΩΤΑ. Η σελίδα
     του πελάτη έδειχνε 21 extras σε μία στήλη — μακρινάρι που έσπρωχνε τις
     δόσεις και το σύνολο κάτω από το fold. */
  /* ΟΤΙ ΠΛΗΡΩΘΗΚΕ ΔΕΝ ΕΜΦΑΝΙΖΕΤΑΙ. Ο server ήδη το κόβει (yms_pay_link_items),
     αλλά η σελίδα σερβίρεται ΚΑΙ από το prod, όπου το api μπορεί να είναι
     παλιότερο και να στέλνει ακόμη `paid:true`. Ένα φίλτρο εδώ σημαίνει ότι ο
     πελάτης δεν βλέπει ποτέ λογαριασμό για κάτι εξοφλημένο. */
  const unpaid: any[] = shownItems.filter((it: any) => !it.paid);
  const fixedItems: any[] = unpaid.filter((it: any) => !it.optional);
  /* Σειρά μέσα στο μπλοκ: ΠΡΩΤΑ ό,τι έστειλε ο υπάλληλος (τικαρισμένο), ΜΕΤΑ ο
     υπόλοιπος κατάλογος (ξετικάριστο). Ο πελάτης βλέπει πρώτα τι συμφωνήθηκε. */
  const extraItems: any[] = unpaid.filter((it: any) => it.optional)
    .slice().sort((a: any, b: any) => Number(!!a.offer) - Number(!!b.offer));

  /* ═══ ΤΑ ΜΠΛΟΚ ═══════════════════════════════════════════════════════════
     Κάθε σκέλος που έστειλε ο υπάλληλος είναι ΞΕΧΩΡΙΣΤΗ ΠΛΗΡΩΜΗ: δικό του
     σύνολο, δικό του κουμπί. ΠΟΤΕ κοινό σύνολο — ο πελάτης που ήθελε να
     πληρώσει μόνο τη δόση δεν πρέπει να βλέπει ένα νούμερο που περιέχει και
     extras και εγγύηση. Εμφανίζονται ΜΟΝΟ όσα υπάρχουν στον σύνδεσμο· ο server
     χρεώνει ΜΟΝΟ το μπλοκ που πατήθηκε (pay-link.php → $block). */
  const packItems: any[] = fixedItems.filter((it: any) => it.purpose === 'charter_pack');
  /* ΔΥΟ ΞΕΧΩΡΙΣΤΑ ΣΚΕΛΗ, ΟΧΙ ΕΝΑ. Η δέσμευση και το damage waiver μπορούν να
     ζητηθούν ΜΑΖΙ («Security + Damage»): το ένα δεσμεύει και λύνεται μετά το
     check-out, το άλλο χρεώνεται και κόβει ΑΠΥ. Μαζεμένα σε ένα μπλοκ, ένα
     κουμπί θα προσπαθούσε να κάνει και τα δύο με μία κίνηση στον πάροχο. */
  const holdItems: any[] = fixedItems.filter((it: any) => it.purpose === 'deposit');
  const waiverItems: any[] = fixedItems.filter((it: any) => it.purpose === 'damage_waiver');
  const depItems:  any[] = [...holdItems, ...waiverItems];
  /* ΕΛΕΥΘΕΡΟ ΠΟΣΟ — ξεχωριστό μπλοκ. Είναι `balance` στη βάση (μειώνει τον
     ναύλο), αλλά ΔΕΝ μπερδεύεται με το αυτόματο σκέλος του υπολοίπου: ο
     πελάτης δεν το αλλάζει, το πληρώνει ή όχι. */
  const isCustom = (it: any) => it.purpose === 'balance' && it.code === 'custom';
  const customItems: any[] = fixedItems.filter(isCustom);
  const balItems:  any[] = fixedItems.filter((it: any) => it.purpose === 'balance' && !isCustom(it));

  /* ΤΟ ΤΙΚ ΟΡΩΝ ΕΜΦΑΝΙΖΕΤΑΙ ΜΟΝΟ ΑΝ Ο ΣΥΝΔΕΣΜΟΣ ΖΗΤΑ ΝΑΥΛΟ. Σύνδεσμος μόνο για
     εγγύηση ή extras δεν έχει τι να ζητήσει να αποδεχθεί ο πελάτης. */
  const hasCharterBlock = instOptions.length > 0 || customItems.length > 0 || balItems.length > 0;

  /* ΕΝΕΡΓΗ ΔΕΣΜΕΥΣΗ: το μπλοκ εγγύησης δεν δείχνει κουμπί — δείχνει ότι έγινε. */
  const depLock: any = (link as any)?.deposit_lock || { active: false };
  const sumOf = (arr: any[]) => arr.reduce((n: number, it: any) => n + (it.amount_cents || 0), 0);
  const extrasTotal = extraItems.reduce(
    (n: number, it: any) => n + (picked[it.code] ? (it.amount_cents || 0) : 0), 0);

  /* ΕΝΑ ΚΟΥΤΙ = ΕΝΑ ΜΠΛΟΚ = ΜΙΑ ΠΛΗΡΩΜΗ. Απλή συνάρτηση, ΟΧΙ component: ένα
     component ορισμένο μέσα στο render ξαναστήνεται σε κάθε πληκτρολόγηση και
     τα checkbox/radio θα έχαναν την εστίαση. */
  const payBlock = (title: string, block: PayBlock, total: number,
                    body: any, hint?: string) => (
    <div className="yms-msec" key={block}>
      <div className="yms-card-h" style={{ marginBottom: 7 }}>
        {title}{hint ? <span className="yms-hint"> — {hint}</span> : null}
      </div>
      {body}
      <div className="yms-mrow" style={{ borderTop: '1px solid var(--line)', marginTop: 10, paddingTop: 9 }}>
        <span style={{ flex: 1 }}>{t.total}</span>
        <span className="yms-mono" style={{ fontWeight: 700, fontSize: 15, color: 'var(--chart)' }}>
          {formatMoneyEU(total / 100)}</span>
      </div>
      <div className="yms-toolbar" style={{ marginTop: 10 }}>
        {/* ΧΩΡΙΣ ΑΠΟΔΟΧΗ ΟΡΩΝ ΔΕΝ ΠΛΗΡΩΝΕΙ ΚΑΝΕΙΣ — ΓΙΑ ΤΟΝ ΝΑΥΛΟ. Ο έλεγχος
            είναι εδώ, στο κουμπί, κι όχι μόνο ως μήνυμα: ένα τικ που
            «προτείνεται» δεν είναι αποδοχή. Εγγύηση, extras και charter pack
            δεν κλειδώνουν από αυτό. */}
        <button className="yms-btn yms-btn-primary yms-btn-lg"
                disabled={busy || total <= 0 || (blockNeedsTerms(block) && !termsOk)}
                title={blockNeedsTerms(block) && !termsOk ? t.termsRequired : undefined}
                onClick={() => start(block)}>
          {busy ? t.working : `${t.pay} — ${formatMoneyEU(total / 100)}`}
        </button>
      </div>
    </div>
  );

  /** Σειρές σκελών χωρίς επιλογή — ό,τι στάλθηκε, πληρώνεται ολόκληρο. */
  const itemRows = (arr: any[]) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {arr.map((it: any, i: number) => (
        <div className="yms-mrow" key={it.code || i}>
          <span style={{ flex: 1 }}>{it.name}</span>
          {((it.includes || []).length > 0 || unitNote(it))
            ? <PriceBreakdownPopup title={it.name} priceCents={it.amount_cents}
                              lines={it.includes || []} note={unitNote(it)}
                              className="yms-pop-right" />
            : <span className="yms-mono" style={{ fontWeight: 600 }}>
                {formatMoneyEU((it.amount_cents || 0) / 100)}</span>}
        </div>
      ))}
    </div>
  );

  /* ═══ Ο ΣΥΝΔΕΣΜΟΣ ΕΙΝΑΙ ΓΙΑ ΚΑΡΤΑ ═══════════════════════════════════════════
     Ο «manual» (τραπεζικό έμβασμα / πληρωμή στη βάση) είναι εργαλείο ΥΠΑΛΛΗΛΟΥ:
     σημαίνει «θα το εισπράξουμε αλλού» και δεν εισπράττει τίποτα online. Στη
     σελίδα του πελάτη εμφανιζόταν ισότιμα με την κάρτα, οπότε ο πελάτης τον
     διάλεγε, έπαιρνε οδηγίες εμβάσματος και ο σύνδεσμος καιγόταν χωρίς χρήματα.
     Μένει ενεργός στη βάση — απλώς δεν προσφέρεται εδώ. */
  const payProviders: any[] = (link?.providers || []).filter((p: any) => p.provider !== 'manual');

  const blocked = link && link.status !== 'open';
  const statusText = !link ? '' :
    link.status === 'expired' ? t.expired :
    link.status === 'used' ? t.used :
    link.status === 'cancelled' ? t.cancelled : '';

  return (
    <div className="yms-page yms-shell">
      <div className="yms-mh" style={{ padding: 0 }}>
        <div className="yms-page-in" style={{ padding: '13px 14px 11px', gap: 6 }}>
          <div className="yms-mh-code">{link?.company?.name || t.title}</div>
          {link && !isStandalone && (
            <div className="yms-mh-sub">
              <span>{t.charter}: <b className="yms-mono">{link.booking_number}</b></span>
              {link.vessel && <span>{t.vessel}: <b>{link.vessel}</b></span>}
              {link.start_date && (
                <span>{t.dates}: <b>{formatDateEU(link.start_date)} → {formatDateEU(link.end_date)}</b></span>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="yms-page-in" style={{ paddingTop: 14 }}>
        {err && <div className="yms-note yms-note-err">{err === 'invalid_token' ? t.invalid : err}</div>}
        {notice && <div className="yms-note yms-note-warn">{notice}</div>}
        {/* Όσο τρέχει το παράθυρο χάριτος του server. Ζωντανό μετρητή, ώστε ο
            πελάτης να βλέπει ότι κάτι συμβαίνει και να μην ξαναπατά «Πληρωμή». */}
        {waitLeft > 0 && (
          <div className="yms-note yms-note-warn">
            {(t.awaiting || T.en.awaiting).replace('{n}', String(waitLeft))}
          </div>
        )}

        {/* ΔΟΚΙΜΑΣΤΙΚΟ: κόκκινη ταινία όσο ο πάροχος είναι sandbox. */}
        {payProviders.some((p: any) => p.mode === 'sandbox') && (
          <div className="yms-note" style={{ background: '#fef2f2', borderColor: '#fecaca',
                                             color: '#991b1b', fontWeight: 700 }}>{t.sandbox}</div>
        )}

        {link && (blocked ? (
          <div className="yms-msec"><div className="yms-note yms-note-warn">{statusText}</div></div>
        ) : (!link.enabled || !payProviders.length) ? (
          <div className="yms-msec"><div className="yms-note yms-note-warn">{t.noProvider}</div></div>
        ) : handoff ? (
          /* ΜΙΑ ΑΠΟΠΕΙΡΑ ΤΗ ΦΟΡΑ. Μόλις ξεκινήσει πληρωμή ενός μπλοκ, η σελίδα
             δείχνει ΜΟΝΟ αυτή — τα υπόλοιπα μπλοκ ξαναεμφανίζονται όταν ο
             πελάτης γυρίσει (ο σύνδεσμος ξανανοίγει, βλ. yms_pay_link_reopen_if_more). */
          <div className="yms-msec">
            {handoff.open_pos ? (
              <div className="yms-toolbar">
                {handoff.pos?.charge_url
                  ? <a className="yms-btn yms-btn-primary yms-btn-lg" href={handoff.pos.charge_url}
                       target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{t.openPos}</a>
                  : <div className="yms-note yms-note-warn">{t.noProvider}</div>}
                <button className="yms-btn" disabled={busy} onClick={goBack}>{t.back}</button>
              </div>
            ) : (
              <>
                <div className="yms-note yms-note-ok" style={{ marginBottom: 12 }}>
                  <b>{t.thanks}</b>
                  <div className="yms-hint">{t.paidNote}</div>
                </div>
                <div className="yms-card-h" style={{ marginBottom: 6 }}>{t.instructions}</div>
                <p className="yms-hint" style={{ whiteSpace: 'pre-wrap' }}>{handoff.instructions || '—'}</p>
                <div className="yms-toolbar" style={{ marginTop: 12 }}>
                  <button className="yms-btn" onClick={() => downloadReceipt({
                    receipt_no: null, booking_number: link.booking_number, vessel: link.vessel,
                    description: (handoff.items || []).map((x: any) => x.name).join(', ') || link.booking_number,
                    purpose: link.purpose, amount_cents: handoff.amount_cents || 0, currency: link.currency,
                    status: 'pending', kind: handoff.kind, provider: handoff.provider,
                    paid_at: new Date().toISOString(), payer: email,
                  })}>{t.receipt}</button>
                  <div className="sp" style={{ flex: 1 }} />
                  {/* Δεύτερη σκέψη: ο πελάτης γυρίζει στις επιλογές του. */}
                  <button className="yms-btn" disabled={busy} onClick={goBack}>{t.back}</button>
                </div>
              </>
            )}
          </div>
        ) : (
          <>
            {/* ΚΟΙΝΑ ΣΤΟΙΧΕΙΑ — email και τρόπος πληρωμής ισχύουν για ΟΠΟΙΟ μπλοκ
                πατηθεί. Μία φορά επάνω· δεν επαναλαμβάνονται σε κάθε κουτί. */}
            <div className="yms-msec">
              <div className="yms-field">
                <label className="yms-lab">{t.email}</label>
                <input className="yms-in" type="email" value={email}
                       onChange={e => setEmail(e.target.value)} placeholder="name@example.com" />
              </div>
              {payProviders.length > 1 && (
                <div className="yms-field" style={{ marginTop: 12 }}>
                  <label className="yms-lab">{t.how}</label>
                  <div className="yms-toolbar" style={{ gap: 6, flexWrap: 'wrap' }}>
                    {payProviders.map((p: any) => (
                      <button key={p.provider} type="button"
                              className={'yms-btn' + (prov === p.provider ? ' yms-btn-primary' : '')}
                              onClick={() => setProv(p.provider)}>{p.label}</button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* ═══ ΠΡΟΓΡΑΜΜΑ ΠΛΗΡΩΜΩΝ — ΠΑΝΩ ΑΠ' ΟΛΑ ═══════════════════════════════
                Ο πελάτης βλέπει ΠΟΥ ΒΡΙΣΚΕΤΑΙ: τι έκλεισε, τι πληρώνει τώρα, τι
                μένει και πότε. Χωρίς αυτό, κάθε σύνδεσμος διαβάζεται σαν
                ξεχωριστή απαίτηση χωρίς συμφραζόμενα. */}
            {planView.length > 0 && (
              <div className="yms-msec">
                <div className="yms-card-h" style={{ marginBottom: 7 }}>{t.planTitle}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {planView.map((o: any) => {
                    const paid = o.status === 'paid';
                    const now  = o.status === 'now';
                    return (
                      <div className="yms-mrow" key={o.key}
                           style={now ? { fontWeight: 700 } : paid ? { opacity: .6 } : undefined}>
                        <span style={{ flex: 1 }}>
                          {paid ? '✓ ' : ''}{o.label}
                          <em className="yms-hint"> · {o.pct}%</em>
                          {o.due_date && (
                            <em className="yms-hint"
                                style={o.overdue && !paid ? { color: 'var(--danger, #b91c1c)' } : undefined}>
                              {' · '}{t.due} {formatDateEU(o.due_date)}
                            </em>
                          )}
                          <em className="yms-hint">{' · '}
                            {paid ? t.stPaid : now ? t.stNow : t.stPending}</em>
                        </span>
                        <span className="yms-mono"
                              style={{ fontWeight: 600, textDecoration: paid ? 'line-through' : undefined }}>
                          {formatMoneyEU((o.amount_cents || 0) / 100)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* ═══ ΗΔΗ ΠΛΗΡΩΜΕΝΑ (extras · charter pack · εγγύηση) ═══════════════
                Δεν ζητούνται ξανά — φαίνονται για να ξέρει ο πελάτης ότι
                μετρήθηκαν. Δεν μπαίνουν ποτέ στο ποσό που πληρώνει τώρα. */}
            {hasAlready && (
              <div className="yms-msec">
                <div className="yms-card-h" style={{ marginBottom: 7 }}>{t.alreadyTitle}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {paidExtrasCents > 0 && (
                    <div className="yms-mrow">
                      <span style={{ flex: 1 }}>{t.alreadyExtras}
                        {paidExtrasN > 1 ? <em className="yms-hint"> · {paidExtrasN}</em> : null}</span>
                      <span className="yms-mono" style={{ fontWeight: 600, color: 'var(--confirm)' }}>
                        ✓ {formatMoneyEU(paidExtrasCents / 100)}</span>
                    </div>
                  )}
                  {paidPackCents > 0 && (
                    <div className="yms-mrow">
                      <span style={{ flex: 1 }}>{t.alreadyPack}
                        <em className="yms-hint"> · {t.packYes}</em></span>
                      <span className="yms-mono" style={{ fontWeight: 600, color: 'var(--confirm)' }}>
                        ✓ {formatMoneyEU(paidPackCents / 100)}</span>
                    </div>
                  )}
                  {depPhrase && (
                    <div className="yms-mrow">
                      <span style={{ flex: 1 }}>{t.alreadyDep}</span>
                      <span className="yms-mono" style={{ fontWeight: 600, color: depPhrase.color }}>
                        {depPhrase.text}</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ═══ ΟΡΟΙ ΠΛΗΡΩΜΗΣ & ΑΚΥΡΩΣΗΣ ══════════════════════════════════════
                ΠΑΝΩ ΑΠΟ ΤΑ ΚΟΥΜΠΙΑ, όχι στο υποσέλιδο: ο πελάτης πρέπει να το
                δει πριν διαλέξει τι πληρώνει, κι όχι αφού πατήσει. Χωρίς τικ,
                κάθε κουμπί πληρωμής μένει ανενεργό. */}
            {hasTerms && hasCharterBlock && (
              <div className="yms-msec">
                <label className="yms-chk" style={{ alignItems: 'flex-start' }}>
                  <input type="checkbox" checked={termsOk} disabled={busy}
                         onChange={e => setTermsOk(e.target.checked)} />
                  <span style={{ flex: 1 }}>
                    {t.termsAccept}{' '}
                    <button type="button" onClick={() => setTermsOpen(true)}
                            style={{ border: 0, background: 'transparent', padding: 0, cursor: 'pointer',
                                     color: 'var(--chart)', textDecoration: 'underline', font: 'inherit' }}>
                      {t.termsRead}
                    </button>
                  </span>
                </label>
                {!termsOk && <div className="yms-hint" style={{ marginTop: 4 }}>{t.termsRequired}</div>}
              </div>
            )}

            {/* ── ΑΥΤΟΝΟΜΗ ΠΛΗΡΩΜΗ — ΕΝΑ ΜΠΛΟΚ, ΕΝΑ ΚΟΥΜΠΙ ── */}
            {isStandalone && standaloneItems.length > 0 && payBlock(
              t.payment, 'standalone', sumOf(standaloneItems),
              <>
                {itemRows(standaloneItems)}
                {link.charterer && (
                  <div className="yms-hint" style={{ marginTop: 8 }}>
                    {t.payer}: <b>{link.charterer}</b>
                  </div>
                )}
              </>)}

            {/* ── ΔΟΣΗ ΝΑΥΛΟΥ ── */}
            {instOptions.length > 0 && payBlock(t.instalment, 'instalment', instCents,
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {instOptions.map((o: any) => (
                  <label className="yms-chk" key={o.key}>
                    <input type="radio" name="instalment" value={o.key} checked={inst === o.key}
                           disabled={busy} onChange={() => setInst(o.key)} />
                    <span style={{ flex: 1 }}>{o.label}{' '}
                      <em className="yms-hint">({o.pct}% {t.ofCharter}
                        {link.charter_total_cents
                          ? ' — ' + formatMoneyEU(link.charter_total_cents / 100) : ''})</em>
                      {o.due_date && (
                        <em className="yms-hint"
                            style={o.overdue ? { color: 'var(--danger, #b91c1c)', fontWeight: 700 } : undefined}>
                          {' · '}{t.due} {formatDateEU(o.due_date)}{o.overdue ? ` (${t.overdue})` : ''}
                        </em>
                      )}</span>
                    <span className="yms-mono" style={{ fontWeight: 600 }}>
                      {formatMoneyEU((o.amount_cents || 0) / 100)}</span>
                  </label>
                ))}
              </div>, instOptions.length > 1 ? t.pickInstalment : '')}

            {/* ── ΕΛΕΥΘΕΡΟ ΠΟΣΟ ── */}
            {customItems.length > 0 && payBlock(t.purpose_custom || t.purpose_balance,
              'custom', sumOf(customItems), itemRows(customItems))}

            {/* ── ΥΠΟΛΟΙΠΟ ΝΑΥΛΟΥ ── */}
            {balItems.length > 0 && payBlock(t.purpose_balance, 'balance', sumOf(balItems), itemRows(balItems))}

            {/* ── CHARTER PACK ── */}
            {packItems.length > 0 && payBlock(t.purpose_charter_pack || 'Charter pack',
              'charter_pack', sumOf(packItems), itemRows(packItems))}

            {/* ── ΕΓΓΥΗΣΗ / DAMAGE WAIVER ── */}
            {/* ── ΔΕΣΜΕΥΣΗ ΕΓΓΥΗΣΗΣ ── */}
            {holdItems.length > 0 && (depLock.active ? (
              /* ΗΔΗ ΔΕΣΜΕΥΜΕΝΗ — ΚΑΝΕΝΑ ΚΟΥΜΠΙ. Ένα δεύτερο πάτημα θα δέσμευε
                 άλλα 4.000 € σε αληθινή κάρτα· ο server το κόβει με 409, αλλά ο
                 πελάτης δεν πρέπει καν να δει το κουμπί. */
              <div className="yms-msec" key="deposit-locked">
                <div className="yms-card-h" style={{ marginBottom: 7 }}>{t.purpose_deposit}</div>
                <div className="yms-note yms-note-ok" style={{ marginBottom: 0 }}>
                  <b>✓ {t.depHeldTitle} — {formatMoneyEU((depLock.amount_cents || 0) / 100)}</b>
                  <div className="yms-hint" style={{ marginTop: 4 }}>{t.depHeldNote}</div>
                </div>
              </div>
            ) : payBlock(t.purpose_deposit, 'deposit', sumOf(holdItems),
              <>
                {itemRows(holdItems)}
                {/* ΜΙΑ ΓΡΑΜΜΗ ΑΝΤΙ ΓΙΑ ΟΡΟΥΣ: ο πελάτης χρειάζεται να ξέρει ότι
                    τα λεφτά δεσμεύονται και δεν χάνονται — τίποτε άλλο. */}
                <div className="yms-hint" style={{ marginTop: 8 }}>{t.depositNote}</div>
              </>))}

            {/* ── DAMAGE WAIVER ── ξεχωριστό κουμπί: είναι ΧΡΕΩΣΗ, όχι δέσμευση.
                Δεν κλειδώνει από ενεργή δέσμευση — ο πελάτης που μόλις δέσμευσε
                πρέπει να μπορεί να πληρώσει και το waiver του ίδιου συνδέσμου. */}
            {waiverItems.length > 0 && payBlock(t.purpose_damage_waiver, 'damage_waiver', sumOf(waiverItems),
              <>
                {itemRows(waiverItems)}
                <div className="yms-hint" style={{ marginTop: 8 }}>{t.waiverNote}</div>
              </>)}

            {/* ── EXTRAS ── */}
            {extraItems.length > 0 && payBlock(t.extrasTitle, 'extra', extrasTotal,
              <div className="yms-chkgrid">
                {extraItems.map((it: any, i: number) => (
                  <label className="yms-chk" key={it.code || i}>
                    <input type="checkbox" checked={!!picked[it.code]} disabled={busy}
                           onChange={e => setPicked(p => ({ ...p, [it.code]: e.target.checked }))} />
                    <span style={{ flex: 1 }}>{it.name}
                      {it.in_charter && <em className="yms-hint"> · {t.inCharter}</em>}</span>
                    <PriceBreakdownPopup title={it.name} priceCents={it.amount_cents}
                                    lines={it.includes || []} note={unitNote(it)}
                                    className="yms-pop-right" />
                  </label>
                ))}
              </div>, t.extrasHint)}

            {link.expires_at && (
              <p className="yms-hint" style={{ marginTop: 4 }}>
                {t.expires}: {formatDateEU(link.expires_at)}
              </p>
            )}
          </>
        ))}
      </div>

      {/* ═══ ΤΟ ΚΕΙΜΕΝΟ ΤΩΝ ΟΡΩΝ ══════════════════════════════════════════════
          Έρχεται από τις ρυθμίσεις της βάσης — καμία αντιγραφή στον κώδικα. Ο
          πελάτης μπορεί να το δει και στις δύο γλώσσες όταν υπάρχουν και οι δύο:
          ο σύνδεσμος έχει τη δική του γλώσσα, αλλά οι νομικοί όροι διαβάζονται
          συχνά στα αγγλικά. Απόδοση ως απλό κείμενο (pre-wrap) — ποτέ HTML από
          textarea ρυθμίσεων. */}
      {termsOpen && (
        <div onClick={() => setTermsOpen(false)}
             style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)', zIndex: 4000,
                      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div onClick={e => e.stopPropagation()}
               style={{ background: '#fff', borderRadius: 12, maxWidth: 720, width: '100%',
                        maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '18px 22px 10px' }}>
              <b style={{ fontSize: 16 }}>{t.terms}</b>
              {termsTexts.en && termsTexts.el && (
                <span style={{ display: 'flex', gap: 4, marginLeft: 8 }}>
                  {(['en', 'el'] as const).map(l => (
                    <button key={l} type="button" onClick={() => setTermsLang(l)}
                            style={{ padding: '3px 9px', borderRadius: 6, cursor: 'pointer', fontSize: 12,
                                     fontWeight: 700, border: termsLang === l ? '2px solid #2563eb' : '1px solid #cbd5e1',
                                     background: termsLang === l ? '#eff6ff' : '#fff',
                                     color: termsLang === l ? '#1e40af' : '#334155' }}>
                      {l === 'en' ? 'EN' : 'ΕΛ'}
                    </button>
                  ))}
                </span>
              )}
              <button onClick={() => setTermsOpen(false)} aria-label={t.close}
                      style={{ marginLeft: 'auto', border: 0, background: 'transparent',
                               fontSize: 24, cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ overflow: 'auto', padding: '0 22px 8px', whiteSpace: 'pre-wrap',
                          fontSize: 14, lineHeight: 1.7, color: '#334155' }}>
              {termsBody}
            </div>
            <div style={{ padding: '12px 22px 18px', borderTop: '1px solid #e5e7eb',
                          display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              {/* Αποδοχή ΚΑΙ από μέσα: ο πελάτης που μόλις τους διάβασε δεν
                  χρειάζεται να κλείσει το παράθυρο για να τσεκάρει το κουτί. */}
              <label className="yms-chk" style={{ flex: 1 }}>
                <input type="checkbox" checked={termsOk}
                       onChange={e => setTermsOk(e.target.checked)} />
                <span>{t.termsAccept}</span>
              </label>
              <button className="yms-btn" onClick={() => setTermsOpen(false)}>{t.close}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
